import styled from 'styled-components/macro';

export const StyledDetailsList = styled.ul`
  padding: 0 0 0 10px;
  list-style: none;
`;
